
import { IdentityClientSettings } from "@gsgroup/gsgroup-react-ui";
import { BackendData } from "./backendDataParser";
import { AppSettings } from "../../@types/AppSettings";

export function getSelectedClient() {
    try {
        const selectedClientJson = localStorage.getItem('selectedClient');

        if (selectedClientJson === null) {
            throw new Error('Selected backend cannot be null');
        }

        const selectedClient: BackendData = JSON.parse(selectedClientJson);

        return selectedClient;
    } catch (error) {
        console.log(error);

        throw error;
    }
}

const APP_SETTINGS_KEY = "APP_SETTINGS_KEY";

export function saveAppSettings(appSettings: AppSettings) {
    const localStorageValue = localStorage.getItem(APP_SETTINGS_KEY);

    const appSettingsAsJson = JSON.stringify(appSettings);

    if (localStorageValue !== appSettingsAsJson) {
        localStorage.setItem(APP_SETTINGS_KEY, appSettingsAsJson);
    }
}

export function getAppSettings() {
    try {
        const appSettingsAsJson = localStorage.getItem(APP_SETTINGS_KEY);

        if (appSettingsAsJson === null) {
            throw new Error('App Settings cannot be null');
        }

        const appSettings: AppSettings = JSON.parse(appSettingsAsJson);

        return appSettings;
    } catch (error) {
        console.log(error);

        throw error;
    }
}